// Cores dos chips na lista de conversas do WhatsApp Inbox.
//
// Conexao = METADADO secundario (qual numero recebeu) -> chip neutro cinza
// uniforme. Antes pintava verde/vermelho/roxo/teal/rose por operadora,
// criando "carnaval de cores" na lista (reportado pelo Douglas).
//
// Equipe = CATEGORICO (qual time atende) -> escala brand-* com /15 opacity.
// Antes usava cores semanticas (info/warning/success) que se confundiam
// com os badges de ESTADO (nao lida, prioridade, etc).

/**
 * Apresenta o nome da conexao em Title Case. Muitas conexoes estao
 * cadastradas em CAPS no banco ("TOTAL - BRUNO SILVA - 5294"), o que
 * polui a lista. Normaliza so apresentacao; banco intacto.
 */
export function formatConnectionName(nome: string): string {
  if (!nome) return nome;
  return nome
    .toLowerCase()
    .replace(/(^|[\s\-/])([a-záàâãéêíóôõúç])/g, (_, sep, ch) => sep + ch.toUpperCase());
}

/**
 * Chip da conexao: neutro cinza por padrao. E metadado, nao estado —
 * nao precisa cor identificadora. O operador identifica pelo TEXTO,
 * nao pela cor.
 *
 * EXCECAO (Douglas 04/08): o CANAL colore. Verde = API oficial (Cloud API),
 * ambar = nao oficial (Baileys/QR). Isso NAO traz de volta o "carnaval": so
 * as linhas que estao no Bee360 tem canal conhecido; todo o resto segue cinza.
 * A cor vem da CONVERSA (`canal_atual`), nao da conexao — uma linha do Bee vive
 * nos dois canais ao mesmo tempo, entao dizer que a linha e "oficial" seria falso.
 * Mesma paleta do selo na bolha do ChatWindow, pra ler igual nos dois lugares.
 */
export function getConnectionBadgeClasses(_nome: string, canal?: string | null, provider?: string | null): string {
  if (canal === 'oficial') {
    return 'bg-emerald-500/10 text-emerald-700 border border-emerald-500/30 dark:text-emerald-400 dark:border-emerald-500/40';
  }
  if (canal === 'nao_oficial') {
    return 'bg-amber-500/10 text-amber-700 border border-amber-500/30 dark:text-amber-400 dark:border-amber-500/40';
  }
  if (provider === 'evolution_go') {
    return 'bg-brand-vinho/10 text-brand-vinho border border-brand-vinho/30 dark:bg-brand-vinho/25 dark:text-brand-rose dark:border-brand-vinho/40';
  }
  return 'bg-muted text-muted-foreground border border-border';
}

// ─── Equipes ────────────────────────────────────────────────────────────
// Escala brand-* com opacity 15% — mantem identidade categorica visivel
// (cada equipe tem sua cor da paleta Prime) sem agredir visualmente.
const EQUIPE_COLOR_MAP: Record<string, string> = {
  diretoria:  'bg-brand-vinho/15 text-brand-vinho border border-brand-vinho/30 dark:bg-brand-vinho/25 dark:text-brand-rose dark:border-brand-vinho/40',
  consultivo: 'bg-brand-bordeaux/15 text-brand-bordeaux border border-brand-bordeaux/30 dark:bg-brand-bordeaux/25 dark:text-brand-rose dark:border-brand-bordeaux/40',
  qualidade:  'bg-brand-borgonha/15 text-brand-borgonha border border-brand-borgonha/30 dark:bg-brand-borgonha/25 dark:text-brand-rose dark:border-brand-borgonha/40',
  total:      'bg-brand-mid/15 text-brand-mid border border-brand-mid/30 dark:bg-brand-mid/25 dark:text-brand-rose dark:border-brand-mid/40',
  prime:      'bg-brand-rose/15 text-brand-rose border border-brand-rose/30 dark:bg-brand-rose/25 dark:text-brand-rose dark:border-brand-rose/40',
  fresh:      'bg-brand-rose/15 text-brand-rose border border-brand-rose/30 dark:bg-brand-rose/25 dark:text-brand-rose dark:border-brand-rose/40',
};

const EQUIPE_FALLBACK = 'bg-muted text-muted-foreground border border-border';

export function getEquipeBadgeClasses(equipe: string | null | undefined): string {
  if (!equipe) return EQUIPE_FALLBACK;
  const lower = equipe.toLowerCase();
  for (const [key, classes] of Object.entries(EQUIPE_COLOR_MAP)) {
    if (lower.includes(key)) return classes;
  }
  return EQUIPE_FALLBACK;
}
